import { useMutation } from "@tanstack/react-query";
import { getCategoryFormQueryId } from "../../pages/categoryForms/utils";
import { api } from "../../utils";
import polyglot from "../../utils/polyglot";
import { useFetch, useToast } from "../hooks";

export const useGetFormData = ({
  id,
  previous_job_id,
  category_origin_id,
  version,
}) =>
  useFetch(window.location.pathname, {
    params: { category: id, previous_job_id, category_origin_id, version },
    queryKey: getCategoryFormQueryId({ id }),
    refetchOnWindowFocus: false,
  });

export const useCheckJobId = () =>
  useMutation(({ id }) => api.get("/jobs/check_id", { params: { id } }));

export const useAddCustomer = () =>
  useMutation(({ first_name, last_name, date_of_birth, email, phone }) =>
    api.post("/concierges/create_customer", {
      first_name,
      last_name,
      date_of_birth,
      email,
      phone,
    })
  );

export const usePostForm = () => {
  const toast = useToast();
  return useMutation((values) => api.post("/jobs", values), {
    onError: () => {
      toast.danger(polyglot.t("common.problem_has_occurred"));
    },
  });
};

export const useCheckEmail = () =>
  useMutation((params) => api.get("/users/check_email", { params }));

export const useGetAvailabilities = (
  { private_jobber_id, start_date, end_date, nb_hours },
  options
) =>
  useFetch(`/users/${private_jobber_id}/availabilities`, {
    params: { start_date, end_date, nb_hours },
    queryKey: [
      "AVAILABILITIES",
      { private_jobber_id, start_date, end_date, nb_hours },
    ],
    ...options,
  });

export const useFetchDistance = (
  { destination_address_location, address_location },
  options
) =>
  useFetch(
    `/jobs/distance_and_duration?latitude=${address_location?.latitude}&longitude=${address_location?.longitude}&destination_latitude=${destination_address_location?.latitude}&destination_longitude=${destination_address_location?.longitude}`,
    {
      ...options,
    }
  );
